<template>
  <el-container class="tui-content" style="display: block;">
    <el-row  class="tui-el">
      <el-col :span="4">目标词及功能选择</el-col>
      <el-col :span="8"style="text-align: center;width: 40%;">excel上传</el-col>
    </el-row>
    <el-row  class="tui-el"  style="margin-top: 20px;">
      <el-col :span="8">
        <el-select v-model="atype"  filterable placeholder="请选择">
            <el-option
              v-for="item in types"
              :key="item.t"
              :label="item.name"
              :value="item.t">
            </el-option>
        </el-select>
        <el-select v-model="value"  filterable placeholder="请选择">
            <el-option
              v-for="item in list"
              :key="item.label"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>

      </el-col>
      <el-col :span="4" style="text-align: center;">
        <el-upload
            class="upload-demo"
            ref="upload1"
            :action="action()"
            :on-preview="handlePreview"
            :before-upload="beforeUpload"
            :data="uploadData"
            :on-error = "error"
            :on-success="successResave"
            :on-remove="handleRemove"
            :file-list="fileList"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
        </el-upload>

      </el-col>
      <el-col :span="4" style="text-align: center;">
        <el-upload
            class="upload-demo"
            ref="upload"
            :action="actionAll()"
            :on-preview="handlePreview"
            :before-upload="beforeUpload"
            :data="uploadData"
            :on-error = "error"
            :on-success="successResave"
            :on-remove="handleRemove"
            :file-list="fileList"
            :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUploadAll">完全覆盖</el-button>
        </el-upload>

      </el-col>
      <el-button type="primary" @click='down()'>下载</el-button>

    </el-row>
    <el-dialog
      title="完全覆盖验证:请输入验证词"
      :visible.sync="keysDialogVisible"
      width="30%"
      center>
      <input type="text" v-focus="picFocusStatus" class="searchT" v-model="keys"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="keysDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doUpload()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
       return {
        types:[{'t':'s','name':'S2'},{'t':'s3','name':'S1'},{'t':'w','name':'W'},{'t':'w2','name':'G1'},{'t':'w3','name':'G2'},{'t':'s2','name':'中断S'}],
        list: [],
        atype:'s',
        value:'',
        uploadData:{},
        file:'',
        fileList:[],
        keys:'',
        keysDialogVisible:false
      }
    },
	directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
    },

	methods:{
    down(){
      window.open('http://120.79.0.150/downexcel?lid='+this.value+'&type='+this.atype)

    },
    action(){
      return "http://120.79.0.150/upexcel"
    },
    actionAll(){
      return "http://120.79.0.150/upexcelall"
    },
    doUpload() {
      if(this.keys == 'self'){
        this.$refs.upload.submit();
        let formData = new FormData();
        this.keysDialogVisible = false
      }else{
        this.msg('验证词不正确','error')
        this.keysDialogVisible = false
      }



    },
    submitUploadAll() {
      this.keysDialogVisible = true


    },
    submitUpload() {
      this.$refs.upload1.submit();
      let formData = new FormData();


    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

       console.log(file);
     },
     beforeUpload (file) {

        this.uploadData = {lid:this.value,type:'s',};

           let promise = new Promise((resolve) => {
               this.$nextTick(function () {
                   resolve(true);
               });
           });
           return promise;
    },
    //上传成功钩子
    successResave(response, file, fileList){
      console.log(response)
      if(response.code==200){
         alert('上传成功')

      }
    },
    //失败钩子
     error(response, file, fileList){
           console.log(response)
     },

    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://y31p.yoooooo.com/index.php/index/data/pythonImgList'
    	})
    	.then(res=>{
    		this.list = res.data;
        this.value = this.list[0]['value']

    	})
    	.catch(err=>{

    	});
    },


    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .tui-content{
    margin-left: 24%;
    margin-top: 100px;
  	width: 100%;
  	height: 100%;
  }
  .tui-el{
    width: 80%;
  }
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/main/sexcel.vue